import { Action } from "@ngrx/store";
import { ISTVMDigital } from '@hub-workspace/apps/logged-home/src/app/shared/interfaces/stvm-digital.interface';

export class STVMDigitalAction implements Action {

    public static getPortabilities = '[STVMDigital] get_portabilities';
    public static getPortabilitiesError = '[STVMDigital] get_portabilities_error';
    public static getPortabilitiesSuccess = '[STVMDigital] get_portabilities_success';

    public static acceptPortability = '[STVMDigital] accept_portability';
    public static acceptPortabilityError = '[STVMDigital] accept_portability_error';
    public static acceptPortabilitySuccess = '[STVMDigital] accept_portability_success';

    constructor(
        public type: string,
        public payload?: any,
        public portabilities?: Array<ISTVMDigital>,
    ) { }
}
